module.exports = __webpack_public_path__ + "static/0015-550b87509666cd7ca82aa90279e42aa8.png";